import { render, staticRenderFns } from "./MyPortfolioProjectsPage.vue?vue&type=template&id=417d530c&scoped=true"
import script from "./MyPortfolioProjectsPage.vue?vue&type=script&lang=ts"
export * from "./MyPortfolioProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./MyPortfolioProjectsPage.vue?vue&type=style&index=0&id=417d530c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d530c",
  null
  
)

export default component.exports